module.exports = __webpack_public_path__ + "img/Pre_Occupational_Cleaning.f5e83464.jpg";